import React from "react";

const CardInterest = ({
  width,
  height,
  marginLeft = 32,
  marginBottom = 20,
  data,
  borderRadius,
  padding = 0,
  handleCategory,
}) => {
  return (
    <div
      className="nib-box interest-box "
      style={{
        width,
        height,
        marginLeft,
        marginBottom,
        borderRadius,
        padding,
      }}
      onClick={() => {
        handleCategory && handleCategory(data);
      }}
    >
      <div style={{ position: "relative", width: "100%" }}>
        <img
          src={
            data?.category_image ||
            "https://bgz-business.s3.us-east-2.amazonaws.com/FreeBusinessImage.jpg"
          }
          style={{
            width: 132,
            objectFit: "fill",
            height: 132,
            borderRadius: "12px",
            cursor: "pointer",
          }}
          alt=""
        />
         <div
        className="text-center mt-1 interest_text_container"
        style={{
          width: "100%", // Full width
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          flexGrow: 1,
        }}
      >
        {/* Category Name */}
        <h6
          className="text-white interest_category_name"
          style={{
            margin: "0 0 4px 0",
            fontSize: "0.85rem",
            lineHeight: "1.3",
            wordWrap: "break-word",
            overflowWrap: "break-word",
            whiteSpace: "normal",
            textAlign: "center",
            width: "100%",
          }}
          
        >
          {data?.category_name || ""}
        </h6>

        
      </div>
      </div>
    </div>
  );
};

export default CardInterest;
